import { RootState } from './types';
import { DynamoDB } from 'aws-sdk/clients/all';

const state: RootState = {
  dbInstance: new DynamoDB(),
  dbClient: new DynamoDB.DocumentClient(),
  currentTable: '',
  currentDb: '',
  currentRegion: '',
  connectionType: '',
  credentialsExpireAt: '',
  tables: [],
  filterText: '',
  loading: false,
  tableListLoading: false,
  response: {
    title: '',
    type: '',
    message: '',
  },
};

export default state;
